import React, { Component } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import RegisterModalForm from "../RegisterModalForm/RegisterModalForm";
import logo from "../../../assets/Plataformas.jpg"
import { DivRow, Form } from "./RegisterModalPage.styles";

/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : RegisterModalPage
Description : Vista en la cual se visualiza el resto del formulario de registro
Date Autor Modification
================================================================================
30/09/2021 Santiago Coca Rojas Creación – Se implementa la vista del formulario desde cero.
================================================================================ */

class RegisterModalPage extends Component{
    constructor(props){
        super(props);
    }
    render(){
        return(
            <DivRow>
                <Form>
                    <RegisterModalForm email={this.props.location.email}/> 
                </Form>
            </DivRow>
        )
    }
}

export default RegisterModalPage;